import { render, staticRenderFns } from "./averagePriceTab.vue?vue&type=template&id=bfbe58b4&"
import script from "./averagePriceTab.vue?vue&type=script&lang=js&"
export * from "./averagePriceTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports